import { useRentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate } from '@zg-rentals/ts-rental-manager-api-client-react-query';
import { formatAddress } from '@zg-rentals/zillow-rental-manager/utils';

type UseRentZestimateParams = {
  hasAnalyticsRentComps: boolean;
  street: string;
  city: string;
  state: string;
  zip: string;
  unitName?: string;
};

const useRentZestimate = ({ hasAnalyticsRentComps, street, city, state, zip, unitName }: UseRentZestimateParams) => {
  const fullAddress = hasAnalyticsRentComps ? formatAddress({ street, city, state, zip }).formattedCompleteAddress : '';

  const { data: rentZestimateData, isError: isRentZestimateError } =
    useRentalManagerPropertyAddressRentZestimateWebApiHandler_rentZestimate(
      { fullAddress, unit: unitName },
      { enabled: hasAnalyticsRentComps && !!fullAddress },
    );

  return isRentZestimateError ? 0 : (rentZestimateData?.rentZestimate ?? 0);
};

export default useRentZestimate;
